export const parseUrl = (url) => {
  const urlRegex = new RegExp('^(?:\\s*(?:(\\S+):\\/\\/)?(?:(.+))?)?', 'i');
  const regexResult = urlRegex.exec(url);
  return { protocol: regexResult && regexResult[1], url: regexResult && regexResult[2] };
};
